import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFigma16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFigma16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.98 6.12A2.26 2.26 0 0 1 4 4.242C4 3.004 4.965 2 6.154 2h3.692C11.036 2 12 3.004 12 4.241c0 .788-.39 1.48-.98 1.88.59.4.98 1.092.98 1.879 0 1.238-.965 2.241-2.154 2.241h-.04a2.1 2.1 0 0 1-1.458-.591v2.088C8.348 12.99 7.362 14 6.164 14 4.977 14 4 12.999 4 11.759c0-.787.39-1.48.98-1.88C4.39 9.48 4 8.787 4 8s.39-1.48.98-1.88M8.348 8c0 .838.653 1.517 1.458 1.517h.04c.805 0 1.458-.68 1.458-1.517 0-.838-.653-1.517-1.458-1.517h-.04c-.805 0-1.458.68-1.458 1.517m-.696-1.517H6.154c-.805 0-1.458.68-1.458 1.517s.65 1.514 1.454 1.517h1.502zM6.154 10.24H6.15c-.803.003-1.453.681-1.453 1.518 0 .835.66 1.517 1.468 1.517.819 0 1.488-.691 1.488-1.538V10.24zm1.498-4.48H6.154c-.805 0-1.458-.68-1.458-1.518 0-.837.653-1.517 1.458-1.517h1.498zm2.194 0H8.348V2.724h1.498c.805 0 1.458.68 1.458 1.517 0 .838-.653 1.518-1.458 1.518"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFigma16);
